import { render, staticRenderFns } from "./RelatedNews.vue?vue&type=template&id=52f497c0&scoped=true&"
import script from "./RelatedNews.vue?vue&type=script&lang=js&"
export * from "./RelatedNews.vue?vue&type=script&lang=js&"
import style0 from "./RelatedNews.vue?vue&type=style&index=0&id=52f497c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f497c0",
  null
  
)

export default component.exports